import request from '../../config/axiosConfig';
import { CREATE_TAG, DELETE_TAG, GET_LIST_TAGS, GET_TAG_INFO, UPDATE_TAG } from '../../constants/apiEndPoint';

export const getListTagsRequest = async (data) => {
  const result = await request({
    url: GET_LIST_TAGS,
    method: 'POST',
    data,
  });
  return result?.data.data;
};


export const getTagInfoRequest = async (data) => {
  const result = await request({
    url: GET_TAG_INFO,
    method: 'POST',
    data,
  });
  return result?.data.data;
};

export const createTagRequest = async (data) => {
  const result = await request({
    url: CREATE_TAG,
    method: 'POST',
    data,
  });
  return result?.data;
};

export const updateTagRequest = async (data) => {
  const result = await request({
    url: UPDATE_TAG,
    method: 'POST',
    data,
  });
  return result?.data;
};

export const deleteTagRequest = async (data) => {
  const result = await request({
    url: DELETE_TAG,
    method: 'POST',
    data,
  });
  return result?.data;
};
